import React from 'react';

interface ErrorPageProps {
  error: Error | null;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  return (
    <div className="error-page" style={{
      padding: '20px',
      textAlign: 'center',
      maxWidth: '800px',
      margin: '0 auto',
      marginTop: '50px'
    }}>
      <h1>Oops! Something went wrong</h1>
      <p>We're sorry for the inconvenience. Please try refreshing the page or contact support if the problem persists.</p>
      {error && process.env.NODE_ENV === 'development' && (
        <details style={{ whiteSpace: 'pre-wrap', textAlign: 'left', margin: '20px 0' }}>
          <summary>Error Details</summary>
          <p>{error.toString()}</p>
        </details>
      )}
      <button 
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Refresh Page
      </button>
    </div>
  );
};

export default ErrorPage;
